module.exports = __webpack_public_path__ + "static/img/no-create.a5ca7933.png";